import type { JobSeverity, JobType } from '@/features/jobs/types/job'

export type JobFormValues = {
  location_id: string
  job_type: JobType | undefined
  device_attached_id: string | undefined
  reason_for_remediation: string
  assigned_partner_id: string | undefined
  severity: JobSeverity | undefined
  site_reference: string
  latitude: string
  longitude: string
  road_name: string
  town: string
  county: string
  asset_location: string
  what3words: string
  postcode: string
}

export const emptyJobFormValues = (): JobFormValues => ({
  location_id: '',
  job_type: 'new_installation',
  device_attached_id: undefined,
  reason_for_remediation: '',
  assigned_partner_id: undefined,
  severity: undefined,
  site_reference: '',
  latitude: '',
  longitude: '',
  road_name: '',
  town: '',
  county: '',
  asset_location: '',
  what3words: '',
  postcode: ''
})

export type CreateJobPayload = {
  location_id?: string
  job_type?: JobType
  device_attached_id?: number
  reason_for_remediation?: string
  assigned_partner_id?: number
  severity?: JobSeverity
  site_reference?: string
  latitude?: number | string
  longitude?: number | string
  road_name?: string
  town?: string
  county?: string
  asset_location?: string
  what3words?: string
  postcode?: string
}

const optionalTrimmed = (value: string) => {
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : undefined
}

const optionalNumber = (value: string) => {
  const trimmed = value.trim()
  if (!trimmed) {
    return undefined
  }

  const parsed = Number(trimmed)
  return Number.isFinite(parsed) ? parsed : trimmed
}

export const toCreateJobPayload = (values: JobFormValues): CreateJobPayload => {
  const payload: CreateJobPayload = {
    location_id: optionalTrimmed(values.location_id),
    site_reference: optionalTrimmed(values.site_reference),
    road_name: optionalTrimmed(values.road_name),
    town: optionalTrimmed(values.town),
    county: optionalTrimmed(values.county),
    asset_location: optionalTrimmed(values.asset_location),
    what3words: optionalTrimmed(values.what3words),
    postcode: optionalTrimmed(values.postcode),
    latitude: optionalNumber(values.latitude),
    longitude: optionalNumber(values.longitude),
  }

  if (values.device_attached_id) {
    payload.device_attached_id = Number(values.device_attached_id)
  }

  if (values.job_type) {
    payload.job_type = values.job_type
  }

  if (values.severity) {
    payload.severity = values.severity
  }

  if (values.assigned_partner_id) {
    payload.assigned_partner_id = Number(values.assigned_partner_id)
  }

  if (values.job_type === 'remediation') {
    const reason = optionalTrimmed(values.reason_for_remediation)
    if (reason) {
      payload.reason_for_remediation = reason
    }
  }

  return payload
}
